#import "../fragments/inbound-sms-rules-fragment.graphql"

query GetInboundSmsRules {
    inboundSmsRules {
        ...InboundSmsRulesFragment
    }
}
